import React, { Fragment } from "react";

import { Mobile, NotMobile } from "../../../../../../../hocs/Responsive";
import { RoamingInfo } from "../../../../../../../components/roamingInfo/RoamingInfo";
import { TableSearch } from "../../../../../../../components/table/components";
import { MobileSortRoamingCounter } from "../../../../../../home/devices/roamingDeviceTable/components";
import { RoamingLimitReachedWarning } from "../../../../../../../components/roamingInfo/RoamingLimitReachedWarning";

export const ProfileRoamingDevicesTableHeader = () => {
  return (
    <Fragment>
      <NotMobile>
        <RoamingInfo />
      </NotMobile>
      <TableSearch />
      <Mobile>
        <MobileSortRoamingCounter />
      </Mobile>
      <RoamingLimitReachedWarning />
    </Fragment>
  );
};
